import { render, staticRenderFns } from "./UserProject.vue?vue&type=template&id=5a366a31"
import script from "./UserProject.vue?vue&type=script&lang=js"
export * from "./UserProject.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./UserProject.vue?vue&type=style&index=1&id=5a366a31&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports